<template>
  <div class="landing-page">
    <div class="hero-wrapper">
      <div class="bg-image"></div>
      <div class="logo"></div>
      <div class="body">
        <div class="left"></div>
        <div class="download-icons-mobile">
          <AppleButton />
          <GoogleButton />
        </div>
        <div class="left-mobile">
          <img alt="Wotive homepage image" src="../assets/landing-page/phone-mobile-hero.webp"/>
        </div>
        <div class="right">
          <h1>THE SOCIAL GYM WORKOUT TRACKING APP!</h1>
          <p>Wotive is a free, powerful and easy to use workout tracking app packed with tons of social features.</p>
          <div class="download-icons">
            <AppleButton />
            <GoogleButton />
          </div>
        </div>
      </div>
      <div class="bottom-btn" @click="goto('features')">
        <p>EXPLORE OUR FEATURES</p>
        <i class="fas fa-angle-down"></i>
      </div>
    </div>
    <div class="features" ref="features">
      <div class="feature-body">
        <div class="left-content text-content-left">
          <h2>Workouts and <br>Exercises made easy.</h2>
          <p>We've made doing and finding workouts simple. Adding your sets and reps with just a couple taps.</p>
          <p>Easily drop any set at any time and a built in rest timer to keep you focused and on track.</p>
        </div>
        <div class="right-content">
          <img alt="Wotive workout logging feature" src="../assets/landing-page/feature_1.webp" />
        </div>
      </div>
      <div class="divider"></div>
      <div class="feature-body reverse-small">
        <div class="left-content">
          <img alt="Wotive workout tracking analysis feature" src="../assets/landing-page/feature_2.webp" />
        </div>
        <div class="right-content text-content-right">
          <h2>Track your progress <br>and analyze your workout.</h2>
          <p>There are loads of ways to keep on top of your own growth as an athlete.</p>
          <p>Check your progress and overall performance on an exercise. Analyze your post workout with in depth heart rate and muscle group data visualization.</p>
        </div>
      </div>
      <div class="action-row ar-1">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-01-mobile.webp" class="mobile-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-01.webp" class="web-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-01-wide.webp" class="large-image">
      </div>
      <div class="feature-body">
        <div class="left-content text-content-left">
          <h2>Share your workouts & encourage your friends.</h2>
          <p>Share your hard work with all your friends and followers. Keep your friends accountable and encourage others to keep smashing it in the gym!</p>
        </div>
        <div class="right-content">
          <img alt="Wotive community feature" src="../assets/landing-page/feature_3.webp" />
        </div>
      </div>
      <div class="divider"></div>
      <div class="feature-body reverse-small">
        <div class="left-content">
          <img alt="Wotive explore feature" src="../assets/landing-page/feature_4.webp" />
        </div>
        <div class="right-content text-content-right">
          <h2>Explore & connect with other gym goers.</h2>
          <p>Our explore feed lets you browse popular posts from the whole community. Make new friends and followers, connect with like minded people, find new groups and get involved.</p>
        </div>
      </div>
      <div class="action-row ar-2">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-02-mobile.webp" class="mobile-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-02.webp" class="web-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-02-wide.webp" class="large-image">
      </div>
      <div class="feature-body">
        <div class="left-content text-content-left">
          <h2>Find new workouts and challenges.</h2>
          <p>Keep moving forward with a selection of free and pro member workouts as well as challenges to keep you motivated.</p>
        </div>
        <div class="right-content">
          <img alt="Wotive custom and pre-made workouts feature" src="../assets/landing-page/feature_5.webp" />
        </div>
      </div>
      <div class="bottom-feature">
        <img alt="Wotive muscle flex" src="../assets/landing-page/flex.webp" />
        <h2>JOIN OUR COMMUNITY TODAY FOR FREE!</h2>
        <p>We've built the app we wanted for the gym, a social platform made for gym goers by gym goers! Don't just write down or log your hard work, track it, flex it, share it and encourage others to reach their goals and dreams.</p>
      </div>
        <div class="download-icons">
          <AppleButton />
          <GoogleButton />
        </div>
      <div class="action-row ar-3">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-03-mobile.webp" class="mobile-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-03.webp" class="web-image">
        <img alt="wotive workout tracker page divider" src="../assets/landing-page/lander-action-03-wide.webp" class="large-image">
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer.vue';
import AppleButton from '@/components/buttons/AppleButton.vue';
import GoogleButton from '@/components/buttons/GoogleButton.vue';

export default {
  name: 'Promo',

  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://wotive.com/'}
    ],
  },

  components: {
    Footer,
    AppleButton,
    GoogleButton,
  },

  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scroll({ top: top, behavior: 'smooth' });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/variables";
$description-font-size-mobile: 14px;
$heading-font-size-mobile: 24px;

$description-font-size-middle: 18px;
$heading-font-size-middle: 36px;

$description-font-size: 24px;
$heading-font-size: 48px;

.landing-page {
  background-color: #F4F7FA;
  overflow-x: hidden;
  .hero-wrapper {
    height: 90vh;
    width: 100%;
    background: linear-gradient(180deg, #2A344B 0%, #1B1C27 100%);
    position: absolute;
    top: 0;

    .bg-image {
      position: absolute;
      right: 0;
      width: 60%;
      height: 100%;
      background-image: url(~@/assets/landing-page/muscle-map.svg);
      background-repeat: no-repeat;
      background-size: cover;
      display: none;
      z-index: 1;
    }
    
    .logo {
      width: 100%;
      height: 100px;
      margin: auto;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      max-width: 200px;
      min-width: 200px;
      background-image: url(~@/assets/landing-page/wotive-logo.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
    }

    .body {
      display: flex;
      flex-direction: column-reverse;
      height: calc(100% - 100px);
      align-items: flex-start;
      justify-content: flex-end;
      position: relative;
      z-index: 3;
    }

    .download-icons-mobile {
      display: flex;
      justify-content: center;
      width: 100%;
      padding-bottom: 40px;
      img {
        height: 40px;
      }
      img:first-of-type {
        margin-right: $spacing-small / 2;
      }
      img:last-of-type {
        margin-left: $spacing-small / 2;
      }
      
    }
    .download-icons {
      display: none;
      img {
        height: 40px;
        margin-right: 8px;
      }
    }

    .left {
      display: none;
      background-image: url(~@/assets/landing-page/app-mockup.webp);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
      height: 600px;
    }
    .left-mobile {
      width: 100%;
      padding: $spacing-base;
      display: flex;
      justify-content: center;
      box-sizing: border-box;

      img {
        width: 90%;
      }
    }

    .right {
      color: white;
      padding: $spacing-base;
      width: 100%;
      box-sizing: border-box;
        
      h1, h2 {
        width: 100%;
        text-transform: uppercase;
        margin-bottom: 10px;
        font-weight: 700;
        text-align: center;
        font-size: $heading-font-size-mobile;
      }

      p {
        width: 100%;
        margin-top: 0;
        font-weight: 500;
        text-align: center;
        font-size: $description-font-size-mobile;
      }
    }
    
    .bottom-btn {
      position: absolute;
      bottom: 0;
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: center;
      height: 50px;
      align-items: center;
      flex-direction: column;
      user-select: none;
      cursor: pointer;
      z-index: 4;
      p {
        color: #FFF;
        font-size: 14px;
        font-weight: 500;
        padding: 0;
        margin: 0;
      }
      i {
        color: #848489;
        font-size: 25px;
      }
    }
  }

  .features {
    margin-top: 90vh;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;

    .action-row {
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      width: 100%;

      .mobile-image {
        display: block;
      }
      .web-image {
        display: none;
      }
      .large-image {
        display: none;
      }


      img {
        width: 100%;
      }
    }

    .divider {
      background-image: url(~@/assets/landing-page/divider-mobile.webp);
      max-width: 1200px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 90%;
      height: 40px;
    }

    .reverse-small {
      flex-direction: column-reverse !important;
    }

    .feature-body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      max-width: 1200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: $spacing-large;
      box-sizing: border-box;

      h1, h2 {
        font-weight: 500;
        color: $sec0;
        text-transform: uppercase;
        margin-bottom: 10px;
        font-size: $heading-font-size-mobile;
        text-align: center;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        color: $sec3;
        font-size: $description-font-size-mobile;
        text-align: center;
      }

      .left-content {
        max-width: 600px;
        width: 100%;

        img {
          width: 100%;
        }
      }

      .right-content {
        max-width: 600px;
        width: 100%;

        img {
          width: 100%;
        }
      }

      .text-content-right {
        margin-left: 20px;
      }
    }

    .download-icons {
      display:flex;
      margin-bottom: $spacing-large * 2;
      margin-top: 24px;
      img {
        height: 42px;
      }
      img:first-of-type {
        margin-right: $spacing-small/2;
      }
      img:last-of-type {
        margin-left: $spacing-small/2;
      }
    }

    .bottom-feature {
      max-width: 1200px;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: $spacing-large;

      img {
        width: 300px;
      }

      h1, h2 {
        font-weight: 500;
        color: $sec0;
        text-transform: uppercase;
        margin-bottom: 10px;
        text-align: center;
        font-size: $heading-font-size-mobile;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        color: $sec3;
        text-align: center;
        font-size: $description-font-size-mobile;
      }
    }
  }
}

@media all and (min-width: 650px) {
  .landing-page {
    .hero-wrapper {
      height: 100vh;

      .logo {
        max-width: 300px;
        min-width: 200px;
        width: 80%;
      }

      .bottom-btn {
        img {
          width: 26px;
          height: 26px;
        }
      }

      .body {
        display: grid;
        grid-template-columns: 1fr 1fr;
        height: auto;

        .download-icons {
          display: block;
        }

        .download-icons-mobile {
          display: none;
        }

        .left-mobile {
          display: none;
        }
        .left {
          display: block;
        }
        .right {
          margin: auto;
          color: #fff;
          margin-left: 20px;
          padding: 0;
          width: auto;
          
          h1, h2 {
            font-size: $heading-font-size;
            text-align: left;
            width: 80%;
          }

          p {
            font-size: $description-font-size;
            text-align: left;
            width: 80%;
          }
        }
      }
    }

    .features {
      margin-top: 100vh;
      .reverse-small {
        flex-direction: row !important;
      }

      .action-row {
        .mobile-image {
          display: none;
        }
        .web-image {
          display: block;
        }

        img {
          width: 100%;
        }
      }

      .divider {
        background-image: url(~@/assets/landing-page/divider.webp);
      }

      .feature-body {
        flex-direction: row;
        margin-top: $spacing-large * 4;
        margin-bottom: $spacing-large * 4;

        h1, h2 {
          text-align: left;
          font-size: $heading-font-size-middle;
        }

        p {
          text-align: left;
          font-size: $description-font-size-middle;
        }
      }
      .bottom-feature {
        h1, h2 {
          font-size: $heading-font-size-middle;
        }

        p {
          font-size: $description-font-size-middle;
        }
      }
    }
  }
}

@media all and (min-width: 1000px) {
  .landing-page {
    .hero-wrapper {
      background: $sec0;
      .bg-image {
        display: block;
      }

      .body {
        .right {
          h1, h2 {
            width: 60%;
          }
          p {
            width: 60%;
          }
        }
      }
    }
    .features {
      .feature-body {
        h1, h2 {
          font-size: $heading-font-size;
        }

        p {
          font-size: $description-font-size;
        }
      }
      .bottom-feature {
        h1, h2 {
          font-size: $heading-font-size;
        }

        p {
          font-size: $description-font-size;
        }
      }
    }
  }
}

@media all and (min-width: 1900px) {
  .landing-page {
    .features {
      .feature-body {
        padding: 0;
      }
    }
  }
}

@media all and (min-width: 2560px) {
  .landing-page {
    .features {
      .action-row {
        .mobile-image {
          display: none;
        }
        .web-image {
          display: none;
        }
        .large-image {
          display: block;
        }
      }
    }
  }
}
@media all and (max-height: 750px) {
  .landing-page {
    .hero-wrapper {
      height: auto;
      position: relative;
      overflow: auto;

      .bottom-btn {
        position: relative;
        display: none;
      }
    }

    .features {
      margin-top: 0;
    }
  }
}
</style>
